import { useEventListener } from '@vueuse/core';
import { GeneralModal } from '@/views/components/modals/GeneralModal';

const MODAL_ID = 'modal';
const TRIGGER_SELECTOR = '.modal-component__trigger';

class DefaultModal extends GeneralModal {
    constructor() {
        super({
            modalId: MODAL_ID,
            triggerSelector: TRIGGER_SELECTOR,
        });
    }
}

const defaultModal = new DefaultModal();

useEventListener(document, 'DOMContentLoaded', () => {
    defaultModal.initialize();
});
